import { makeStyles, tokens } from '@fluentui/react-components';
export var useMobileWebBottomBarstyles = makeStyles({
    bottomNav: {
        position: 'absolute',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        width: '100%',
        background: tokens.colorNeutralBackground4,
        bottom: '0',
        zIndex: 9999,
        height: '50px',
        flex: '1',
    },
    buttonIcon: {
        background: 'transparent',
        border: 'none',
        padding: '0',
        margin: '8px 0 0 0',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fill: tokens.colorNeutralForeground3,
        cursor: 'pointer',
    },
    buttonText: {
        margin: '0 0 4px',
        fontSize: tokens.fontSizeBase100,
        fontFamily: tokens.fontFamilyBase,
    },
});
//# sourceMappingURL=MobileBottomNavBar.styles.js.map